<template>
    <no-ssr>
        <div class="multi-file-select">
            <span @click="clickHandler" class="input-file-add">
            </span>
            <input type="file" id="multipleFileInput" ref="multiFiles" :name="name" :multiple="multiple" @change="handleFileChange"/>
            <div class="file-list">
                <div v-for="(file, key) in files" :key="reloadKey">
                    <div class="single-file" :id="key">
                        <div :class="{'file-name' : true}">{{cutDocName(file.name, 16)}} <span :class="{'error-size': ((file.size / 1024) > maxSize)}">{{displaySize(file.size)}}</span></div>
                        <span class="file-remove" @click="removeFile(key)">&times;</span>
                    </div>
                </div>
            </div>

        </div>

    </no-ssr>
</template>

<script>
    import StringMixin from '../mixins/StringMixin.js'

    export default {
        data() {
            return {
                files: [],
                reloadKey: 0,
                maxSize: 7168,
            }
        },
        props: {
            value: File,
            multiple: String,
            id: String,
            name: String,
            title: { type: String, default: 'Прикрепить файл' },
            maxSize: {type: Number, default: 7168 },
            titleSelected: { type: String, default: 'Выбранный файл: ' },
        },
        mixins: [StringMixin],
        methods: {
            clickHandler() {
                this.$refs.multiFiles.click();
            },
            displaySize(size){
                let sOversize = '';
                let temSize = (size / 1024).toFixed(2);
                if(temSize > 1024) {
                    sOversize = '';
                    if(temSize > this.maxSize) {
                        sOversize = '(макс. размер '+ (this.maxSize / 1024).toFixed(2) +' Мб) ';
                    }
                    temSize = (temSize / 1024).toFixed(2);
                    return  sOversize + temSize + ' Мб';
                } else {
                    sOversize = '';
                    if(temSize > this.maxSize) {
                        sOversize = '(макс. размер '+ this.maxSize +' Кб) ';
                    }
                    return sOversize + temSize + ' Кб';
                }
            },
            handleFileChange(e) {
                var selectedFiles = e.target.files;
                for (let i=0; i < selectedFiles.length; i++)
                {
                    console.log(selectedFiles[i]);
                    this.files.push(selectedFiles[i]);
                }
                this.$emit('input', selectedFiles);
            },
            removeFile (i) {
                var arrayFiles = this.files;

                var index = arrayFiles.indexOf(arrayFiles[i]);
                if(index == 0 && i == 0) {
                    arrayFiles.shift();
                } else {
                    arrayFiles.splice(index, 1);
                }

                this.reloadKey++;

                this.files = arrayFiles;
                this.$emit('input',arrayFiles);
            }
        }
    }
</script>

<style lang="scss" scoped>

    .file-select {

        & > .select-button {
            display: flex;display: -ms-flexbox;
            flex-flow: row nowrap;
            align-items: center;

            height: 65px;
            padding: 5px 15px 25px 70px;
            position: relative;
            @include font-size(18px, 22px);
            @include ease(all, 0s);
            text-transform: uppercase;
            text-decoration: none;
            white-space: nowrap;
            cursor: pointer;
            color: $color-text;
            &:before {
                @include pseudo;
                @include size(60px);
                left: 0;
                top: 0;
                background: url('/images/ui/attach-file.png') top left no-repeat;
                background-size: auto 100%;
            }
            .title-select {
                text-decoration: underline;
            }
        }

        & > input[type="file"] {
            display: none;
        }

    }
    .input-file-container input-file-multiple{
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 10px;
        z-index: 1;
    }
    .input-file-container input-file-multiple > span {
        position: absolute;
        right: 0;
        top: 0;
        width: 21px;
        height: 22px;
        cursor: pointer;
        background: url('/images/icons/icon-file-gray.svg') no-repeat;
        background-size: cover;
    }
    .input-file-container input-file-multiple > span:hover {
        background: url('/images/icons/icon-file-blue.svg') no-repeat;
        background-size: cover;
    }
    .input-file-container input-file-multiple input {
        position: absolute;
        right: 0;
        top: 0;
        background-color: red;
        display: block;
        width: 20px;
        height: 20px;
        border: none;
        outline: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        visibility: hidden;
    }
    .input-file-container input-file-multiple .file-list{
        @media (max-width: 600px) {
            width: 95%;
        }
        @media (max-width: 320px) {
            margin-top: 20px;
        }
    }
    .input-file-container input-file-multiple  .single-file  {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        width: 510px;
        @media (max-width: 600px) {
            width: 100%
        }
        @media (max-width: 320px) {
            padding: 12px 0;
            width: 100%;

        }
    }
    .input-file-container input-file-multiple  .single-file .file-name {
        font-family: 'Manrope';
        font-style: normal;
        font-weight: 500;
        font-size: 15px;
        line-height: 24px;
        color: #3F435F;
        padding-left: 32px;
        position: relative;
        width: 450px;
        display: flex;
        @media (max-width: 600px) {
            width: 95%;
        }
        @media (max-width: 320px) {
            width: 93%;
            font-size: 12px;
            line-height: 19px;
        }
    }
    .input-file-container input-file-multiple  .single-file .file-name::before {
        content: '';
        display: block;
        width: 18px;
        height: 22px;
        background: url('/images/icons/icon-doc.svg') no-repeat;
        background-size: cover;
        position: absolute;
        top: 0;
        left: 0;

    }
    .input-file-container input-file-multiple  .single-file .file-name span {
        margin-left: auto;
        display: inline-block;
    }
    .input-file-container input-file-multiple  .single-file .file-name span.error-size {
        color: red;
        font-weight: bold;
    }
    .input-file-container input-file-multiple  .single-file .file-remove {
        display: block;
        font-size: 0;
        width: 10px;
        height: 10px;
        background: url('/images/icons/icon-close.svg') no-repeat;
        background-size: cover;
        cursor: pointer;
    }


</style>



// WEBPACK FOOTER //
// components/shared/_any/InputFileMultiple.vue